import {CreateProps} from "react-admin";
import {CustomCreate} from "../../components/CustomCreate";
import {ChartAccountsForm} from "./ChartAccountsForm";

export const ChartAccountsCreate = (props: CreateProps) => {
  return (
    <CustomCreate {...props} component="div">
      <ChartAccountsForm />
    </CustomCreate>
  );
};
